import {createSelector} from 'reselect';

const getApplication = state => state.application;

const gameConfigSelector = createSelector(
  getApplication,
  (application = {}) => {
    const {template} = application;
    const {primaryColor, secondaryColor, backgroundColor} = template || {};
    return {
      primaryColor,
      secondaryColor,
      backgroundColor,
    };
  }
);
export default gameConfigSelector;
